"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doNotForwardTransientProp = void 0;
var doNotForwardTransientProp = function doNotForwardTransientProp(props) {
  return function (prop, defaultValidatorFn) {
    return props.indexOf(prop) === -1 && defaultValidatorFn(prop);
  };
};
exports.doNotForwardTransientProp = doNotForwardTransientProp;